import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

interface CardItem {
  icon: string; // Bootstrap icon class, e.g. "bi bi-image"
  title: string;
  description: string;
  link?: string;
}

interface CardGridProps {
  cards: CardItem[];
}

const CardGrid: React.FC<CardGridProps> = ({ cards }) => {
  const navigate = useNavigate();

  return (
    <section className='py-5 about-grid-section'>
      <div className='container'>
        <div className='row g-4'>
          {cards.map((card, idx) => (
            <div key={idx} className='col-md-6 col-lg-3'>
              <div
                className={`card h-100 shadow-sm brand-card about-grid-card text-center${
                  card.link ? " about-grid-card--interactive" : ""
                }`}
                onClick={() => {
                  if (card.link) {
                    navigate(card.link);
                  }
                }}
                onKeyDown={(event) => {
                  if (!card.link) {
                    return;
                  }

                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    navigate(card.link);
                  }
                }}
                role={card.link ? "link" : undefined}
                tabIndex={card.link ? 0 : undefined}
              >
                <div className='card-body about-grid-card-body'>
                  <div
                    className='mb-3 fs-1 about-grid-icon'
                    style={{ color: "#352672" }}
                  >
                    <i className={card.icon}></i>
                  </div>
                  <h5 className='card-title about-grid-title text-center'>
                    {card.title}
                  </h5>
                  <p className='card-text about-grid-text text-center'>
                    {card.description}
                  </p>
                  {card.link && (
                    <div className='about-grid-footer'>
                      <Link
                        to={card.link}
                        className='about-grid-view-more'
                        onClick={(event) => event.stopPropagation()}
                      >
                        View More <i className='bi bi-arrow-right-short'></i>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default CardGrid;
